module.exports = __webpack_public_path__ + "img/img31.97d1af02.svg";